<template>
     <div class="login-container">
       <div class="login-card">
         <img src="../../assets/login/logotitle.jpg" alt="Logo" class="login-logo">
         <h2 class="login-title">欢迎使用日志记录</h2>
         <el-form class="login-form" ref="loginForm" :model="loginForm" :rules="loginRules" label-width="0">
           <el-form-item prop="username">
             <el-input
               placeholder="用户名"
               v-model="loginForm.username"
               prefix-icon="el-icon-user"
               class="login-input"
             ></el-input>
           </el-form-item>
           <el-form-item prop="password">
             <el-input
               type="password"
               placeholder="密码"
               v-model="loginForm.password"
               prefix-icon="el-icon-lock"
               class="login-input"
               @keyup.enter.native="handleLogin"
             ></el-input>
           </el-form-item>
           <el-form-item>
             <el-button class="login-btn" type="primary" @click="handleLogin"
                        @keyup.enter.native="handleKeyPress">登录</el-button>
           </el-form-item>
         </el-form>
         <div class="login-footer">
<!--           <el-link href="javascript:void(0)" @click="showRegisterDialog()">立即注册</el-link>-->
           <!-- 注册链接，使用router-link实现页面跳转 -->
           <router-link to="/register" class="register-link">
             立即注册
           </router-link>
           <div class="copyright">
               <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">© 2024 京ICP备2024071583号-1</a>
           </div>
         </div>
       </div>
     </div>
   </template>
<script>
// eslint-disable-next-line no-unused-vars
import RSA from '../utils/RSAencrypt'
export default {
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin () {
      const { username, password } = this.loginForm
      // 可以在这里添加任何验证逻辑，比如检查用户名和密码是否为空
      if (!username || !password) {
        this.$message.error('用户名和密码不能为空')
        return
      }

      const loginData = {
        username: this.loginForm.username,
        password: RSA.RSAencrypt(this.loginForm.password)
      }

      this.$axios.post('/api/auth/login', loginData)
        .then(response => {
          // 处理响应数据
          if (response.data.code === 200) {
            // 登录成功
            this.$message.success('登录成功')
            // 存储token和用户信息，比如在localStorage或者Vuex
            localStorage.setItem('tokenName', response.data.data.tokenName + '342')
            localStorage.setItem('tokenValue', response.data.data.tokenValue + '234')
            // 跳转到首页或者其他页面
            this.$router.push({ path: '/home' })
          } else {
            // 登录失败
            this.$message.error('登录失败: ' + response.data.message)
          }
        })
        .catch(error => {
          // 处理错误情况
          this.$message.error('登录请求失败')
          console.error('登录请求失败：', error)
        })
    },
    handleKeyPress (event) {
      if (event.key === 'Enter') {
        this.handleLogin()
      }
    }
  }
}
</script>
<style scoped>
   .login-container {
     display: flex;
     justify-content: center;
     align-items: center;
     height: 100vh;
     width: 100%;
     background: url('../../assets/login/logo-bj5.jpg') no-repeat center center/cover;
     overflow: hidden;
     position: relative;
   }
   .login-card {
     width: 100%;
     max-width: 400px;
     padding: 30px;
     background: white;
     border-radius: 8px;
     box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
   }
   .login-logo {
     display: block;
     margin: 0 auto 20px;
     width: 120px;
     height: auto;
   }
   .login-title {
     text-align: center;
     margin-bottom: 20px;
     color: #333;
   }
   .login-form {
     margin-bottom: 20px;
   }
   .login-input {
     background: #f7f7f7;
     border-color: #e6e6e6;
     color: #333;
   }
   .login-btn {
     width: 100%;
     background: linear-gradient(to right, #2154FA, #000099);
     border-color: transparent;
     color: white;
     transition: transform 0.3s ease-in-out;
   }
   .login-btn:hover {
     cursor: pointer;
     transform: scale(1.03);
   }
   .login-footer {
     display: flex;
     flex-direction: column;
     align-items: center;
     margin-top: 15px;
   }
   .el-link {
     color: #2154FA;
     text-decoration: none;
   }
   .el-link:hover {
     text-decoration: underline;
   }
   .copyright {
  font-size: 0.8em;
  color: #666; /* 指定颜色 */
  margin-top: 10px;
}

  .copyright a {
    color: inherit; /* 继承父元素的颜色 */
    text-decoration: none; /* 移除下划线 */
  }

  .copyright a:hover,
  .copyright a:active,
  .copyright a:focus {
    text-decoration: none; /* 鼠标悬浮、点击或聚焦时也不显示下划线 */
     color: inherit; /* 保持颜色不变 */
  }

  .copyright a:visited {
    color: inherit; /* 访问后的链接颜色也继承 */
  }
   .register-link {
     color: #2154FA; /* 链接颜色 */
     text-decoration: none; /* 移除下划线 */
     font-weight: bold;
   }

   .register-link:hover {
     text-decoration: underline; /* 鼠标悬浮时添加下划线 */
   }
</style>



// WEBPACK FOOTER //
// src/components/login/Login3.vue